@if (isLoading == true) {
<div class="loading-spinner">Loading...</div>
} @else {
<app-bc-fob-m-package
  [packageData]="dropdownData?.Package"
></app-bc-fob-m-package>
<!-- <app-bc-fob-m-additives></app-bc-fob-m-additives> -->
<app-bc-fob-m-viscosity-modifier
  [vmData]="dropdownData?.VM"
></app-bc-fob-m-viscosity-modifier>
<app-bc-fob-m-ppd [ppdData]="dropdownData?.PPD"></app-bc-fob-m-ppd>
<app-bc-fob-m-base-oil [baseOilData]="dropdownData?.BO"></app-bc-fob-m-base-oil>
<div class="sum-container">
  <p class="sum-container f-column">Sum</p>
  <div
    class="ratio-value centered"
    [ngClass]="{ 'exceeds-limit': isRatioP1Over }"
    [title]="isRatioP1Over ? 'Base-oil ratios must equal 100%' : ''"
  >
    {{ totalRatioP1 | number : "1.2-4" }}
    <span *ngIf="isRatioP1Over" class="warning-icon">⚠️</span>
  </div>
  <div class="ratio-value centered">
    {{ totalTreatP1 | number : "1.2-4" }}
  </div>
  <div
    class="ratio-value centered"
    [ngClass]="{ 'exceeds-limit': isRatioP2Over }"
    [title]="isRatioP2Over ? 'Base-oil ratios must equal 100%' : ''"
  >
    {{ totalRatioP2 | number : "1.2-4" }}
    <span *ngIf="isRatioP2Over" class="warning-icon">⚠️</span>
  </div>
  <div class="ratio-value centered">
    {{ totalTreatP2 | number : "1.2-4" }}
  </div>
</div>
}
